var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyStarred = function SvgEmptyStarred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#empty-starred_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5472E4",
    d: "M15.01 41.99V24.46c0-4.705 3.054-6.996 6.815-5.115s6.815 7.23 6.815 11.936V79.5l-3.407-1.706V29.86c0-2.352-1.527-5.027-3.408-5.968-1.88-.94-3.407.206-3.407 2.558v17.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB1FF",
    d: "M28.642 31.28c0-4.705-3.055-10.053-6.816-11.935-1.608-.804-3.087-.846-4.253-.262L53.922.895c1.166-.583 2.645-.541 4.253.263 3.762 1.882 6.815 7.23 6.815 11.935v48.22l-18.174-4.546L28.64 79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253974",
    d: "m25.233 40.284-6.815 3.41V26.45c0-2.352 1.526-3.499 3.407-2.558s3.408 3.616 3.408 5.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5472E4",
    d: "m46.427 21.997 3.223 7.891 7.425-2.305-5.434 9.92 1.367 9.655-6.58-1.76-6.58 8.271 1.367-11.007-5.434-4.544 7.424-5.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F6424",
    d: "m40.947 54.22 1.367-11.007-5.434-4.544 7.425-5.042 3.223-11.08 3.062 1.532-3.223 11.08-7.424 5.042 5.434 4.544-1.367 11.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD60A",
    d: "m52.912 29.767 5.262-1.633 3.064 1.532-7.426 2.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC53D",
    d: "m50.59 24.08 3.222 7.891 7.426-2.305-5.434 9.92 1.367 9.655-6.581-1.76-6.58 8.271 1.367-11.007-5.434-4.544 7.425-5.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F6424",
    d: "m36.88 38.67 3.063 1.531 5.434 4.544-3.063-1.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD60A",
    d: "m44.305 33.627 3.063 1.532-7.425 5.042-3.063-1.532z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-starred_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.01.5h49.98v79H15.01z"
  })))));
};
export default SvgEmptyStarred;